import { Grid } from "@mui/material";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgencyId, AgencyIds } from "../../../../reducers/states/agency";
import { AgencyDelimeter, GetAgencyFilterLabel, WspDistrictFilterKey } from "../../../../reducers/states/agency/wsp";
import { FeedStatusLevel } from "../../../../enums/feed-status";
import { IRootReducer } from "../../../../reducers";
import AgencyFilter from "./agency-filter";
import { useSearchParams } from "react-router-dom";
import { useJogs } from "../../../../hooks/jogs";

const tooltips = new Map<WspDistrictFilterKey, string>([
  [WspDistrictFilterKey.TAC_D1, "WSP dispatch information for Pierce and Thurston counties. (WSP District 1)"],
  [WspDistrictFilterKey.SEA_D2, "WSP dispatch information for King County. (WSP District 2)"],
  [WspDistrictFilterKey.YAK_D3, "WSP dispatch information for Yakima, Benton, Franklin, Walla Walla, Garfield, Columbia and Asotin counties. (WSP District 3)"],
  [WspDistrictFilterKey.SPO_D4, "WSP dispatch information for Adams, Ferry, Lincoln, Pend Oreille, Spokane, Stevens and Whitman counties. (WSP District 4)"],
  [WspDistrictFilterKey.VAN_D5, "WSP dispatch information for Clark, Cowlitz, Lewis, Klickitat, and Skamania counties. (WSP District 5)"],
  [WspDistrictFilterKey.WEN_D6, "WSP dispatch information for Chelan, Douglas, Grant, Kittitas and Okanogan counties as well as the southwest corner of Adams County. (WSP District 6)"],
  [WspDistrictFilterKey.NW_D7, "WSP dispatch information for Snohomish, Skagit, Island, San Juan, and Whatcom counties. (WSP District 7)"],
  [WspDistrictFilterKey.PEN_D8, "WSP dispatch information for Clallam, Grays Harbor, Jefferson, Kitsap, Mason, Pacific and Wahkiakum Counties. (WSP District 8)"],
]);

const AgencyFilters: FC<{ handleAgencySelect: (event: ChangeEvent<HTMLInputElement>) => void }> = (props) => {
  const feedStatus = useSelector((state: IRootReducer) => state.dispatchEventFeedReducer.feedStatus);
  const userPrefStore = useSelector((state: IRootReducer) => state.userInfoReducer.userPreferences);
  const [agencyFilters, setAgencyFilters] = useState<{ agencyId: AgencyId, label: string, tooltip: string }[]>([]);
  const [searchParams] = useSearchParams();

  const jogs = useJogs();

  // todo: jcavner: create a hook to reuse for this ability to check for env and value of a search param value
  const isStatusCheckDisabled = () => {
    const checkFeed = searchParams.get('checkFeed');
    const domain = window.location.origin.split("//")[1]?.split(":")[0]?.toLowerCase();
    const isDisabledForNonProd = ["dev.vcc.systems", "stage.vcc.systems"].includes(domain) && checkFeed !== "t";
    const isDisabledForLocalhost = domain === "localhost" && checkFeed === "f";
    return isDisabledForNonProd || isDisabledForLocalhost;
  }

  const isFeedDown = (id: AgencyId) => {
    if (isStatusCheckDisabled()) return false;

    // Use split to handle "ids" like "2: D2", where "2" is the AgencyId for WSP
    let feed = feedStatus.find(s => s.agencyId === id.split(AgencyDelimeter)[0]);
    
    if (feed) {
      return feed.status !== FeedStatusLevel.OK;
    }

    // Default to not showing the indicator if we don't have the feed status retrieved
    return false;
  }

  useEffect(() => {
    const filterMap = new Map<string, { agencyId: AgencyId, label: string, tooltip: string }>();
    userPrefStore.jogFilters?.forEach((jogId) => {
      const jog = jogs.get(jogId);      
      jog?.agencies.forEach((agency) => {
        if (agency.isFilter && agency.id !== AgencyIds.WSP) {
          filterMap.set(agency.id, {
            agencyId: agency.id,
            label: GetAgencyFilterLabel(agency),
            tooltip: tooltips.get(agency.id) || "Dispatch information for " + agency.name 
           });
        }
      });
    });

    setAgencyFilters([...filterMap.values()]);

  }, [userPrefStore.jogFilters, jogs]);

  return (
    <Grid container alignItems="center">
      {agencyFilters.map((filter) => {
        return (
          <Grid item key={filter.agencyId}>
            <AgencyFilter
              label={filter.label}
              filterKey={filter.agencyId}
              selectedFilters={userPrefStore.agencyFilters || []}
              isFeedDown={isFeedDown(filter.agencyId)}
              tooltip={filter.tooltip}
              handleAgencySelect={props.handleAgencySelect}
            />
          </Grid>
        )
      })}
    </Grid>
  );
};

export default AgencyFilters;